var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',[_vm._v("利用状況確認")])]),_c('UsageConfirmation')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',[_vm._v("アプリ別利用状況")])]),_c('AppUsageComfirmation')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }